import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '@dm/core';
import { LineChartModule } from '../line-chart/line-chart.module';
import { IndicatorChartComponent } from './indicator-chart.component';

@NgModule({
    declarations: [IndicatorChartComponent],
    exports: [IndicatorChartComponent],
    imports: [
        CommonModule,
        CoreModule,
        LineChartModule,
    ],
})
export class IndicatorChartModule { }
